<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field v-model="localFilter.creator" label="Tìm theo vai trò giao việc" clearable outlined dense />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field v-model="localFilter.receiver" label="Tìm theo vai trò nhận việc" clearable outlined dense />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" outlined @click="applyFilter"> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      default: () => ({
        creator: '',
        receiver: '',
      }),
    },
  },
  data() {
    return {
      localFilter: {
        creator: (this.filter && this.filter.creator) || '',
        receiver: (this.filter && this.filter.receiver) || '',
      },
    }
  },
  methods: {
    applyFilter() {
      this.$emit('onFilterChanged', this.localFilter)
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-start;
  }
}
</style>
